/**
 * Folder UI atoms — client-side preferences persisted in localStorage
 */
import { atomWithStorage } from 'jotai/utils';

export type FolderSortMode = 'manual' | 'name' | 'cardCount' | 'updatedAt';

export const folderSortModeAtom = atomWithStorage<FolderSortMode>('mtgcraft:folder-sort-mode', 'manual');
